import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "antd";
import styles from "./style.module.scss";

const FormatWaitlistButton = ({ joined, loading, onJoin }) => {
  const { t } = useTranslation();

  return (
    <Button
      size="small"
      type={joined ? "default" : "primary"}
      ghost={joined}
      loading={loading}
      disabled={joined}
      className={styles.waitlistBtn}
      onClick={(e) => {
        e.stopPropagation();
        onJoin();
      }}
    >
      {joined
        ? t("feedbackCapture.waitlist_joined")
        : t("feedbackCapture.waitlist_join")}
    </Button>
  );
};

export default FormatWaitlistButton;
